import { render, staticRenderFns } from "./grXinx.vue?vue&type=template&id=18640137&scoped=true"
import script from "./grXinx.vue?vue&type=script&lang=js"
export * from "./grXinx.vue?vue&type=script&lang=js"
import style0 from "./grXinx.vue?vue&type=style&index=0&id=18640137&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18640137",
  null
  
)

export default component.exports